module.exports = __webpack_public_path__ + "img/0001.b746cb2a.jpg";